<template>
    <b-row
        align-v="center"
        class="OTgraphMainGraphLine"
        v-bind:class="'OTgraphMainGraphLine-'+ LineClassName"
    >
        <b-col cols="3" class="OTgraphMainGraphLineCellLabel">{{LineLabel}}</b-col>
        <b-col
            cols="6"
            class="OTDataCaseBar OTDataCaseBar OTgraphMainGraphLineCellGraph"
            :class="{LineLabel}"
        >
            <span class="OTGraphsBarOutside">
                <span class="OTGraphBar" v-bind:style="LineWidth"></span>
            </span>
        </b-col>
        <b-col cols="3" class="OTgraphMainGraphLineCellValue">{{ LinetotalDoc }}</b-col>
    </b-row>
</template>

<script>
export default {
    props: ["LineLabel", "LinetotalDoc", "LineWidth", "LineClassName"]
};
</script>

